"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonyName = void 0;
var ColonyName;
(function (ColonyName) {
    ColonyName["CALLISTO"] = "Callisto";
    ColonyName["CERES"] = "Ceres";
    ColonyName["ENCELADUS"] = "Enceladus";
    ColonyName["EUROPA"] = "Europa";
    ColonyName["GANYMEDE"] = "Ganymede";
    ColonyName["IO"] = "Io";
    ColonyName["LUNA"] = "Luna";
    ColonyName["MIRANDA"] = "Miranda";
    ColonyName["PLUTO"] = "Pluto";
    ColonyName["TITAN"] = "Titan";
    ColonyName["TRITON"] = "Triton";
    ColonyName["CERES_REBALANCED"] = "Ceres(\u2696)";
    ColonyName["EUROPA_REBALANCED"] = "Europa(\u2696)";
    ColonyName["GANYMEDE_REBALANCED"] = "Ganymede(\u2696)";
    ColonyName["IO_REBALANCED"] = "Io(\u2696)";
    ColonyName["LUNA_REBALANCED"] = "Luna(\u2696)";
    ColonyName["PLUTO_REBALANCED"] = "Pluto(\u2696)";
    ColonyName["IAPETUS"] = "Iapetus";
    ColonyName["MERCURY"] = "Mercury";
    ColonyName["HYGIEA"] = "Hygiea";
    ColonyName["TITANIA"] = "Titania";
    ColonyName["VENUS"] = "Venus";
    ColonyName["LEAVITT"] = "Leavitt";
    ColonyName["PALLAS"] = "Pallas";
})(ColonyName = exports.ColonyName || (exports.ColonyName = {}));
//# sourceMappingURL=ColonyName.js.map